import { uuid } from './../../util/index'

export default {
    document_db_id: null,
    document_url_id: null,
    entity_id: null,
    name: 'Title this Data Pipeline Planner...',
    description: 'Add a compelling description of the data pipeline',
    entity_name: 'Pipeline Planner',
    entity_group: 'Pipeline Planner',
    columns: [
        {
            name: 'Data Sources',
            tasks: []
        }
    ],
    team_id: null,
    team_shared: false,
}
